module.exports = __webpack_public_path__ + "5d9a5949b2b0d7b6c4336a52bce64819.fbx";